<div class="bg-gray-50 min-h-screen">
  <div class="w-full px-4">
    <feature-mediator #mediator
      [rootDataProvider]="getPointOfServices"
      [level1DataProviders]="level1Providers"
      [nestedListTypes]="nestedListTypes"
      [shouldFetchLookupsOnRootSelect]="shouldFetchLookupsOnRootSelect">

      <!-- Bouton Refresh manuel -->
      <div class="mb-4">
        <!--<button (click)="refreshFromAPI()" class="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          🔄 Recharger depuis l’API
        </button>
        <button (click)="refreshUIFromStore()" class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">
          🔁 Rafraîchir l’UI depuis le Store
        </button>
        <button (click)="logStoreContent()" class="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700">
          📋 Log Store dans la console
        </button>

        <button (click)="logStoreIndex()" class="px-4 py-2 bg-purple-600 text-white rounded">
          📊 Log Index
        </button>-->
        <!--<button (click)="refreshEmployees()" class="px-4 py-2 bg-blue-300 rounded">
          Rafraîchir les employés
        </button>-->
      </div>

      @if(HasRequiredClientPermissions) {
      <app-client-list [dataMode]="'api'" [featureContext]="'trucker'" [includedEntities]="mediator.entityNames()" (itemSelected)="onClientSelected($event)"></app-client-list>
      }
      @else if (HasRequiredTenantPermissions) {
      <app-client-stack [dataMode]="'api'" featureContext]="'trucker'" [includedEntities]="mediator.entityNames()" (itemSelected)="onClientSelected($event)"></app-client-stack>
      }

      @if (mediator.hasRootSelected) {
      <!-- Liste des points de service -->
      <app-point-of-service-list [isNested]="true" [nestedData]="pointOfServices()"
        (itemSelected)="mediator.selectLevel1($event)">
      </app-point-of-service-list>

      <app-trucker-activity-list [isNested]="true" [nestedData]="truckerActivities()"> </app-trucker-activity-list>

      <div class="flex flex-wrap items-start gap-x-8 -mt-4">
        <!-- Colonne gauche -->
        <div class="grow basis-[520px] flex flex-col">
          <app-trucker-list [isNested]="true" [nestedData]="truckers()"> </app-trucker-list>
          <app-employee-list [isNested]="true" [nestedData]="employees()"> </app-employee-list>
        </div>
        <!-- Colonne droite -->
        <div class="grow basis-[520px] flex flex-col">
          <app-dock-list [isNested]="true" [nestedData]="docks()"> </app-dock-list>
          <app-tenant-account-list [isNested]="true" [nestedData]="accounts()"> </app-tenant-account-list>
        </div>
      </div>
      }
    </feature-mediator>
  </div>
</div>